import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 122332EC-08DD-438C-BD47-AB332E1E04F6
 * name wifi-strength-off
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wifi-strength-off.svg
 * tags
 */
export const WifiStrengthOffIcon = createSvgIcon(<><path d="M3.27,1.44L2,2.72L4.05,4.77C2.75,5.37 1.5,6.11 0.38,7C4.41,12.06 12,21.5 12,21.5L15.91,16.63L19.23,19.95L20.5,18.68M12,3C10.6,3 9.21,3.17 7.86,3.5L18.18,13.81C20,11.5 22.05,9 23.65,7C20.32,4.41 16.22,3 12,3Z" /></>, 'WifiStrengthOffIcon');
export default WifiStrengthOffIcon